function activateSwatch(swatch) {
  const row = swatch.closest('.card__color-swatches');
  if (!row) return;

  row.querySelectorAll('.card__color-swatch').forEach((sibling) => {
    sibling.classList.toggle('is-active', sibling === swatch);
  });

  const card = swatch.closest('.card');
  if (!card) return;

  // card-quick-add.js listens for this to keep its size availability in
  // sync with whichever color is currently selected, without either file
  // depending on the other's internals.
  card.dispatchEvent(
    new CustomEvent('card:color-change', {
      bubbles: true,
      detail: { color: swatch.getAttribute('aria-label') },
    })
  );

  // Keep the "Tipo - Color" line under the title in sync with whichever
  // swatch is now active, the same way the photo does — garment type never
  // changes, only the color half, so it's read back from the element's own
  // data attribute rather than re-derived here.
  const titleDetail = card.querySelector('[data-card-title-detail]');
  if (titleDetail) {
    const garmentType = titleDetail.getAttribute('data-garment-type');
    const color = swatch.getAttribute('aria-label');
    titleDetail.textContent = garmentType ? `${garmentType} - ${color}` : color;
  }

  const imageUrl = swatch.getAttribute('data-swatch-image');
  if (!imageUrl) return;

  // Update every <img> inside .card__media, not just the first: Dawn's
  // show_secondary_image hover-preview keeps a second image in the DOM
  // that CSS :hover opacity swaps to, so leaving it on the old photo made
  // the change look delayed until the pointer left the card.
  card.querySelectorAll('.card__media .media img').forEach((img) => {
    img.srcset = '';
    img.src = imageUrl;
  });
}

function handleSwatchEvent(event) {
  const swatch = event.target.closest('.card__color-swatch');
  if (!swatch) return;
  event.preventDefault();
  event.stopPropagation();
  activateSwatch(swatch);
}

// pointerdown fires immediately on both mouse and touch, independent of any
// click-gating/hover-simulation quirk on touch devices, so selection and the
// image swap happen on first tap. click is kept as a safety net so the
// browser's default link navigation never fires on any input type.
document.addEventListener('pointerdown', handleSwatchEvent);
document.addEventListener('click', handleSwatchEvent);
